import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTripleDotsHorizontal = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M14.5 6q0 2-2 2h-1q-2 0-2-2t2-2h1q2 0 2 2M14.5 12q0 2-2 2h-1q-2 0-2-2t2-2h1q2 0 2 2M12.5 20q2 0 2-2t-2-2h-1q-2 0-2 2t2 2z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTripleDotsHorizontal)
export default ForwardRef
